/**
 * @desc 更新计费重和单位
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: defs.tms.TransportDjfRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/updateBillingFee`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
